import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import Draft_card_popup from "./Draft_card_popup";
import { BookText, CalendarDays, MoreVertical } from "lucide-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// css comes in published_file.css

const DraftAssessBoxHW = (props) => {
  const navigate = useNavigate();
  const [showUnsavedPrompt, setShowUnsavedPrompt] = useState(false);
  const [pendingNav, setPendingNav] = useState(false);
  const reduceParaGraph = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.substring(0, length) + "...";
  };

  const handleNavClick = (e) => {
    if (e.target.closest && e.target.closest('[data-no-nav="true"]')) {
      // click came from popup trigger — ignore navigation
      return;
    }
    const localSaved = localStorage.getItem(`DraftQHomeWorkLocal-${props.id}`);
    console.log("localSaved found");
    if (localSaved) {
      setShowUnsavedPrompt(true); // show dialog first
      setPendingNav(true); // mark navigation pending
    } else {
      // no unsaved changes → direct navigate
      navigate("/Draft_Q_list_HW", {
        state: { homework_id: props.id },
      });
    }
  };

  return (
    <>
      {/* <div className="hw_published_card2">
        <div className="hw_card_class_section d-flex align-items-center justify-content-between">
          <NavLink
            to={`/Draft_Q_list_HW`}
            className="link"
            state={{ homework_id: props.id }}
          >
            <span>
              {" "}
              {`${props?.standard} - ${props?.section} | `}{" "}
              <span title={props?.Draft_subject}>
                {reduceParaGraph(props?.Draft_subject, 27)}
              </span>
            </span>
          </NavLink>
          <Popup
            trigger={
              <img
                src="/images/menu-dots-vertical 1.svg"
                className="hw_card_three_dot"
                alt=""
              />
            }
            content={
              <div className="hw_popup_box_size">
                <Draft_card_popup
                  props={props.id}
                  setDeleteConfirmation2={props.setDeleteConfirmation1}
                  setHwId2={props.setHwId1}
                />
              </div>
            }
            on="click"
            hideOnScroll
            position="bottom right"
          />
        </div>
        <NavLink
          to={`/Draft_Q_list_HW`}
          className="link"
          state={{ homework_id: props.id }}
        >
          <div className="mt-1 hw_card_name" title={props.Draft_assessName}>
            {" "}
            {props.Draft_assessName}{" "}
          </div>

          <span className="hw_card_deadline">
            Updated on :&nbsp;
            <span className="hw_card_date">
              {props.updated_date} | {props.updated_time}
            </span>
          </span>
        </NavLink>

        <div className="PopupBox"><AssessPopupBox /></div>
      </div> */}

      <div
        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
        style={{
          backgroundColor: "#FDEFE3",
          borderTop: "2px solid #8D4B28",
          borderRight: "4px solid #8D4B28",
          borderBottom: "1px solid #8D4B28",
          borderLeft: "1px solid #8D4B28",
          borderRadius: "0.75rem",
          cursor: "pointer",
        }}
        onClick={handleNavClick}
      >
        {/* Header: Class | Section | Subject + 3 Dots */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <span className="poppins-semibold">
              {" "}
              {`${props?.standard} - ${props?.section} | `}{" "}
              <span title={props?.Draft_subject} className="poppins-semibold">
                {reduceParaGraph(props?.Draft_subject, 27)}
              </span>
            </span>
          </div>

          <div data-no-nav="true" onClick={(e) => e.stopPropagation()}>
            <Popup
              trigger={<MoreVertical size={18} style={{ cursor: "pointer" }} />}
              content={
                <div className="p-2">
                  <Draft_card_popup
                    props={props.id}
                    setDeleteConfirmation2={props.setDeleteConfirmation1}
                    setHwId2={props.setHwId1}
                  />
                </div>
              }
              on="click"
              hideOnScroll
              position="bottom right"
            />
          </div>
        </div>

        <div>
          <div className="d-flex align-items-center mb-1">
            <BookText size={16} className="me-2 text-dark" />
            <div className="text-truncate poppins-semibold">
              {props.Draft_assessName}
            </div>
          </div>
          <div
            className="d-flex align-items-center text-muted"
            style={{ fontSize: "0.875rem" }}
          >
            <CalendarDays size={16} className="me-2 text-dark" />
            <span>
              <div className="d-flex align-items-start flex-column">
                <span className="me-1"> Updated on : </span>
                <span className=" text-dark">
                  {" "}
                  {props.updated_date} | {props.updated_time}
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
      {
        <Dialog
          open={showUnsavedPrompt}
          onClose={() => setShowUnsavedPrompt(false)}
        >
          <DialogTitle>Unsaved Changes Found</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You already have unsaved changes for this draft. Do you want to
              continue with them or discard and load original draft?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setShowUnsavedPrompt(false);
                console.log("canceled");
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setShowUnsavedPrompt(false);
                navigate("/Draft_Q_list_HW", {
                  state: {
                    homework_id: props.id,
                    localData: true,
                  },
                });
              }}
              variant="contained"
            >
              Continue with Unsaved
            </Button>
            <Button
              onClick={() => {
                localStorage.removeItem(`DraftQAssesmentLocal-${props.id}`);
                setShowUnsavedPrompt(false);
                navigate("/Draft_Q_list_HW", {
                  state: {
                    homework_id: props.id,
                  },
                });
              }}
              color="error"
              variant="outlined"
            >
              Discard & Load Draft
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};

export default DraftAssessBoxHW;
